module.exports = __webpack_public_path__ + "img/ico_rank_pickup_on.e92acd4.svg";